import { type DocumentSiiStatus } from '@store/skeletor/documents/siiStatuses/getDocumentSiiStatuses/types';

const bySiiStatus = (siiStatus: string) => (record: DocumentSiiStatus) =>
  record.siiStatus === siiStatus;

export { bySiiStatus };
